module.exports = __webpack_public_path__ + "static/media/terroir-from-space-logo.086548a0.png";